<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import PromoModalCloseButton from '../atoms/PromoModalCloseButton.svelte';

	/** Modal title text */
	export let title: string;
	/** Accessible label for close button */
	export let closeAriaLabel: string = 'Close';
	/** Whether in mobile mode (hides close button, centers title) */
	export let isMobile: boolean = false;

	const dispatch = createEventDispatcher<{ close: void }>();
</script>

<div class="promo-modal-header" class:is-mobile={isMobile}>
	<h2 class="promo-modal-header__title">{title}</h2>
	{#if !isMobile}
		<PromoModalCloseButton ariaLabel={closeAriaLabel} on:click={() => dispatch('close')} />
	{/if}
</div>

<style>
	.promo-modal-header {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 0 15px;
		width: 100%;
		box-sizing: border-box;
	}

	/* Mobile header: centered title, smaller padding */
	.promo-modal-header.is-mobile {
		justify-content: center;
		padding: 0 11px 16px 10px;
	}

	.promo-modal-header__title {
		flex: 1;
		margin: 0;
		font-family: 'Inter', sans-serif;
		font-size: 22px;
		font-weight: 600;
		line-height: normal;
		color: var(--color-white, #ffffff);
	}

	/* Mobile title: smaller font, centered, no flex grow */
	.promo-modal-header.is-mobile .promo-modal-header__title {
		flex: none;
		font-size: 18px;
		text-align: center;
	}
</style>
